import { render, staticRenderFns } from "./ApprovalPkwForm.vue?vue&type=template&id=1856c30b&scoped=true&"
import script from "./ApprovalPkwForm.vue?vue&type=script&lang=js&"
export * from "./ApprovalPkwForm.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalPkwForm.vue?vue&type=style&index=0&id=1856c30b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1856c30b",
  null
  
)

export default component.exports